import { get, post, put, del } from '../request'

export const getApplicationByProjects = (ids, state, pagination, filter) =>
  get(`api/applications/find/by/projects`, { ids, state, pagination, filter, time: new Date().getTime() })
export const getApplicationCount = (ids) => get(`api/applications/stat/count`, { ids })
export const getReportByProject = (project, filter = {}) => get('api/applications/generate/report', { project, filter })
export const getReportGroupByProviders = (filter = {}) => get('api/applications/report/group-provider', { filter })
export const createApplication = (data) => post('api/applications', { data })
export const changeState = (application, state, data = {}) => put(`api/applications/${state}/${application}`, { data })
export const deleteApplication = (application) => del(`api/applications/delete/${application}`, {})
export const updateApplication = (application, data) => put(`api/applications/update/${application}`, data)
export const createApplicationImplementation = (data) => post('api/applications/create-implementation', { data })
export const addImplementationDetalisation = (data) =>
  post('api/applications/add-implementation-detalisation', { data })
export const createActualItem = (data) => post('api/applications/add-actual-item', { data })
export const updateApplicationDeliveryDate = (application, data) =>
  put(`api/applications/delivery-date/${application}`, data)
export const removeDetalisationImplementation = (implementationItem, data) =>
  put(`api/applications/remove-detalisation/${implementationItem}`, data)
